module.exports = __webpack_public_path__ + "static/media/BarlowCondensed-ExtraLightItalic.2bb8c1f0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowCondensed-ExtraLightItalic.ttf
// module id = 2866
// module chunks = 51